import SchemeBusinessService from '../services/scheme-business-service';

export const schemeBusiness = {
  namespaced: true,
  state: {
    business: null,
    createVerification: null,
    verification: null,
    verificationScheduleDate: null,
    businessVerificationSearchResult: null,
    lastBusinessVerificationSearchConfig: null,
    businessVerificationPageNumber: 0,
    verificationActivityLog: null,
  },
  actions: {
    get({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setBusiness', null);
      commit('setVerification', null);
      commit('setVerificationScheduleDate', null);
      return SchemeBusinessService.get(payload.schemeId, payload.schemeBusinessId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusiness', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    resubmit({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.resubmit(payload.schemeId, payload.schemeBusinessId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusiness', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    rematch({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.rematch(
        payload.schemeId,
        payload.schemeBusinessId,
        payload.tmln,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusinessLinkPending', {
            linkPending: null,
            tmln: null,
            trustmarkBusinessId: null,
            status: 3,
          });
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    publishtrades({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.publishtrades(payload.schemeId, payload.schemeBusinessId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    createLodgementPortalLogin({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.createLodgementPortalLogin(
        payload.schemeId,
        payload.schemeBusinessId,
        payload.email,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    listLegacyLodgementBranches({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.listLegacyLodgementBranches(
        payload.schemeId,
        payload.schemeBusinessId,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    updateCeaseToTrade({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.updateCeaseToTrade(payload.schemeId, payload.schemeBusinessId, payload).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    createVerification({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.createVerification(payload).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setCreateVerification', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    getVerificationScheduleDate({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.getVerificationScheduleDate(payload).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setVerificationScheduleDate', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    getVerification({ commit }, payload) {
      commit('setIsBusy', true, { root: true });

      if (!this.business) {
        // Get the business first if null
        SchemeBusinessService.get(payload.schemeId, payload.schemeBusinessId).then(
          (result) => {
            commit('setBusiness', result.model);
            return SchemeBusinessService.getVerification(payload).then(
              (result) => {
                commit('setIsBusy', false, { root: true });
                commit('setVerification', result.model);
                return Promise.resolve(result);
              },
              (error) => {
                commit('setIsBusy', false, { root: true });
                return Promise.reject(error);
              },
            );
          },
          (error) => {
            commit('setIsBusy', false, { root: true });
            return Promise.reject(error);
          },
        );
      } else {
        // We aready have the business, so just get the verification
        return SchemeBusinessService.getVerification(payload).then(
          (result) => {
            commit('setIsBusy', false, { root: true });
            commit('setVerification', result.model);
            return Promise.resolve(result);
          },
          (error) => {
            commit('setIsBusy', false, { root: true });
            return Promise.reject(error);
          },
        );
      }
    },
    getFilingHouseFile({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.getFilingHouseFile(payload).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    verificationSearch({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      data.type = 'standard';
      commit('setLastBusinessVerificationSearchConfig', data);
      return SchemeBusinessService.verificationSearch(data).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusinessVerificationSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, {
            root: true,
          });
          return Promise.reject(error);
        },
      );
    },
    verificationSearchAdvanced({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      data.type = 'advanced';
      commit('setLastBusinessVerificationSearchConfig', data);
      return SchemeBusinessService.verificationSearchAdvanced(data).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusinessVerificationSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, {
            root: true,
          });
          return Promise.reject(error);
        },
      );
    },
    getAllVerificationActivityLog({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.getAllVerificationActivityLog(payload).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setVerificationActivityLog', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
  },
  mutations: {
    setBusiness(state, business) {
      state.business = business;
    },
    setBusinessLinkPending(state, newlinkPendingActioned) {
      state.business.schemeBusiness.linkPending = newlinkPendingActioned.linkPending;
      state.business.schemeBusiness.status = newlinkPendingActioned.status;
      state.business.schemeBusiness.tmln = newlinkPendingActioned.tmln;
      state.business.schemeBusiness.trustmarkBusinessId =
        newlinkPendingActioned.trustmarkBusinessId;
    },
    setBusinessActiveTradingStandardsApplication(state, newModel) {
      state.business.schemeBusiness.activeTradingStandardsApplicationReference =
        newModel.applicationReference;
    },
    setCreateVerification(state, newCreateVerification) {
      state.createVerification = newCreateVerification;
    },
    setVerificationScheduleDate(state, newVerificationScheduleDate) {
      state.verificationScheduleDate = newVerificationScheduleDate;
    },
    setVerification(state, newVerification) {
      state.verification = newVerification;
    },
    setBusinessVerificationSearchResult(state, businessVerificationSearchResult) {
      state.businessVerificationSearchResult = businessVerificationSearchResult;
    },
    setLastBusinessVerificationSearchConfig(state, businessVerificationSearchResult) {
      state.lastBusinessVerificationSearchConfig = businessVerificationSearchResult;
    },
    setBusinessVerificationPageNumber(state, newPageNumber) {
      state.businessVerificationPageNumber = newPageNumber;
    },
    setVerificationActivityLog(state, newVerificationActivityLog) {
      state.verificationActivityLog = newVerificationActivityLog;
    },
    clearVerificationActivityLog(state) {
      state.verificationActivityLog = null;
    },
  },
};
